<template>
  <component :is="component" />
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useUserStore } from "@/store/user";
import { defineAsyncComponent } from "vue";
import { getTitle } from "@/utils/title";
import PageLoader from "@/components/v2/page-loader";

defineOptions({
  name: "page404",
});

const userStore = useUserStore();
const isLoggedIn = computed(() => userStore.isLoggedIn);

const component = computed(() =>
  defineAsyncComponent({
    loader: () => (!isLoggedIn.value ? import("@/components/v2/not-found/index.vue") : import("@/components/not-found/index.vue")),
    loadingComponent: PageLoader,
    delay: 0,
  }),
);

onMounted(() => {
  document.title = getTitle("Error 404: page doesn't exists");
});
</script>
